/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable, inject } from '@angular/core'
import { LOCALISATION_VERSION } from '@myprofile-ui/myprofile-localisation-api'
import { cloneDeep } from 'lodash-es'
import { API_MOCK_LOCALISATION_BASE_URL } from '../../mock-api/constants'
import { ProfileMockApi } from '../../mock-api/mock-api.interfaces'
import { ProfileMockApiService } from '../../mock-api/mock-api.service'
import { translationData } from './data'

@Injectable({
  providedIn: 'root',
})
export class TranslationLoaderServiceMockApi implements ProfileMockApi {
  private localeVersion = inject(LOCALISATION_VERSION)
  private mockApiService = inject(ProfileMockApiService)

  private readonly _translation: { [key: string]: any }

  constructor() {
    // Set the mock data
    this._translation = translationData

    // Register the API endpoints
    this.register()
  }

  public register(): void {
    const genericUrls = {
      de: `${API_MOCK_LOCALISATION_BASE_URL}translations/${this.localeVersion}/shared-webcomponents/de_DE_generic.json`,
      us: `${API_MOCK_LOCALISATION_BASE_URL}translations/${this.localeVersion}/shared-webcomponents/en_US_generic.json`,
      gb: `${API_MOCK_LOCALISATION_BASE_URL}translations/${this.localeVersion}/shared-webcomponents/en_GB_generic.json`,
    }

    ;(Object.keys(genericUrls) as (keyof typeof genericUrls)[]).forEach((country) => {
      const url = genericUrls[country]
      this.mockApiService.onGet(url).reply(() => {
        console.log('Mocking request to ', url)
        return [200, cloneDeep(this._translation[country])]
      })
    })

    const urls = {
      de: `${API_MOCK_LOCALISATION_BASE_URL}translations/${this.localeVersion}/shared-webcomponents/de_DE.json`,
      us: `${API_MOCK_LOCALISATION_BASE_URL}translations/${this.localeVersion}/shared-webcomponents/en_US.json`,
      gb: `${API_MOCK_LOCALISATION_BASE_URL}translations/${this.localeVersion}/shared-webcomponents/en_GB.json`,
    }

    ;(Object.keys(urls) as (keyof typeof urls)[]).forEach((country) => {
      const url = urls[country]
      this.mockApiService.onGet(url).reply(() => {
        console.log('Mocking request to ', url)
        return [200, cloneDeep(this._translation[country])]
      })
    })
  }
}
